import { render, staticRenderFns } from "./JG.vue?vue&type=template&id=2813d2ec&scoped=true&"
import script from "./JG.vue?vue&type=script&lang=js&"
export * from "./JG.vue?vue&type=script&lang=js&"
import style0 from "./JG.vue?vue&type=style&index=0&id=2813d2ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2813d2ec",
  null
  
)

export default component.exports